// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const borderStyle: string = `2px solid ${token('color.border')}`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const CloseDrawerButtonWrapper = styled.button({
	width: token('space.500'),
	height: token('space.500'),
	marginTop: token('space.300'),
	marginLeft: token('space.200'),
	padding: 0,
	alignItems: 'center',
	justifyContent: 'center',
	background: 0,
	border: 0,
	borderRadius: '50%',
	color: 'inherit',
	cursor: 'pointer',
	font: token('font.body'),
	'&:hover': {
		backgroundColor: token('color.background.neutral.subtle.hovered'),
	},
	'&:active': {
		backgroundColor: token('color.background.neutral.subtle.pressed'),
		outline: 0,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const HeaderWrapper = styled.div<{ showDivider: boolean }>((props) => ({
	display: 'flex',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderBottom: props.showDivider ? borderStyle : 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	justifyContent: props.showDivider ? 'unset' : 'space-between',
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const ProgressTrackerWrapper = styled.div({
	flexGrow: 1,
	marginBottom: token('space.500'),
	paddingRight: token('space.600'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const HeaderRightContentWrapper = styled.div({
	marginTop: token('space.300', '24px'),
	marginRight: token('space.200', '16px'),
});
